export default __webpack_public_path__ + "static/media/ProximamenteEN.25fb3bb1.png";